import React from 'react';

import hhproFaqButtonClick from '@hh.ru/analytics-js-events/build/xhh/applicant/hhpro/hhpro_faq_button_click';
import { translation, TranslatedComponent } from '@hh.ru/front-static-app';
import { VSpacing, Text } from '@hh.ru/magritte-ui';

import Accordion from 'src/pages/HhProPromo/components/Accordion';

import styles from './styles.less';

const FAQ_INDEX = [0, 1, 2, 3, 4] as const;

const TrlKeys: Record<number, { title: string; description?: string; descriptionList?: Record<string, string> }> = {
    0: {
        title: 'hhpro.promo.faq.0.title',
        descriptionList: {
            0: 'hhpro.promo.faq.0.description.p0',
            1: 'hhpro.promo.faq.0.description.p1',
            2: 'hhpro.promo.faq.0.description.p2',
        },
    },
    1: { title: 'hhpro.promo.faq.1.title', description: 'hhpro.promo.faq.1.description' },
    2: { title: 'hhpro.promo.faq.2.title', description: 'hhpro.promo.faq.2.description' },
    3: {
        title: 'hhpro.promo.faq.3.title',
        description: 'hhpro.promo.faq.3.description',
        descriptionList: {
            0: 'hhpro.promo.faq.3.description.p0',
            1: 'hhpro.promo.faq.3.description.p1',
            2: 'hhpro.promo.faq.3.description.p2',
            3: 'hhpro.promo.faq.3.description.p3',
            4: 'hhpro.promo.faq.3.description.p4',
            5: 'hhpro.promo.faq.3.description.p5',
        },
    },
    4: { title: 'hhpro.promo.faq.4.title', description: 'hhpro.promo.faq.4.description' },
};

const Faq: TranslatedComponent = ({ trls }) => {
    return (
        <div id={styles.replaceColor}>
            {FAQ_INDEX.map((id) => {
                const description = TrlKeys[id].description;
                const descriptionList = TrlKeys[id].descriptionList;
                return (
                    <React.Fragment key={id}>
                        <VSpacing default={12} />
                        <Accordion
                            title={
                                <Text style="contrast" typography="subtitle-1-semibold">
                                    {trls[TrlKeys[id].title]}
                                </Text>
                            }
                            onClick={() => hhproFaqButtonClick({ question: trls[TrlKeys[id].title] })}
                        >
                            <Text style="contrast" typography="paragraph-3-regular">
                                {description && (
                                    <>
                                        {trls[description]}
                                        <VSpacing default={8} />
                                    </>
                                )}
                                {descriptionList && (
                                    <ul>
                                        {Object.values(descriptionList).map((key) => (
                                            <li key={key} className={styles.item}>
                                                {trls[key]}
                                                <VSpacing default={8} />
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </Text>
                        </Accordion>
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default translation(Faq);
